import {
  GET_REVIEWED_CONTRACTS,
  GET_REVIEWED_CONTRACTS_ERROR,
  GET_REVIEWED_CONTRACTS_SUCCESS
} from './ReviewedContractsTable.actions'

const reviewedContractsTableState = {
  errorReviewsList: undefined,
  loadingReviewsList: true,
  reviewedContractsList: []
}

const reviewedContractsTableReducer = (state = reviewedContractsTableState, { payload, type }) => {
  switch (type) {
    case GET_REVIEWED_CONTRACTS: {
      return { ...state, loadingReviewsList: true }
    }
    case GET_REVIEWED_CONTRACTS_SUCCESS: {
      return {
        ...state,
        loadingReviewsList: false,
        reviewedContractsList: payload.reviewedContractsList
      }
    }
    case GET_REVIEWED_CONTRACTS_ERROR: {
      return {
        ...state,
        loadingReviewsList: false,
        errorReviewsList: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default reviewedContractsTableReducer
